import React from "react";
import Icon from "../../components/Detail/Icons";
import FavBtn from "../FavBtn";
import Fancybox from "../Fancybox";
import Destination from "./Destination";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp";
import { FaRegEnvelope } from "@react-icons/all-files/fa/FaRegEnvelope";
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { FaRegCopy } from "@react-icons/all-files/fa/FaRegCopy";

import Link from "next/link";
import { useTranslation } from "../../context/TranslationContext";

const HeaderCard = ({ page }) => {
  const {
    watchVideo,
    person,
    bedRoom,
    bathRoom,
    shareUpper,
    shareViaWhatsapp,
    shareViaMail,
    shareViaFacebook,
    shareViaTwitter,
    copyLink,
  } = useTranslation();
  const { gavelBelgeNo, gavelBasvuruNo } = page;
  return (
    <div className="px-3 sm:px-[1.3rem] lg:px-0">
      {page.video ? (
        <Fancybox>
          <button
            data-fancybox="video"
            data-src={page.video}
            className="bg-white pl-6 pr-5 ml-auto py-4 rounded mb-7 items-center hidden lg:flex"
          >
            <span className="mr-2 font-bold text-13 opacity-50 text-brand-black">
              {watchVideo}
            </span>
            <div className="text-brand-color-secondary">
              <Icon name={"playbutton"}></Icon>
            </div>
          </button>
        </Fancybox>
      ) : (
        <div className="mb-20 pb-1 hidden lg:block"></div>
      )}
      <div className="lg:bg-white lg:border-[3px] border-detail-border-color rounded flex flex-col lg:px-9 lg:pb-7">
        <FavBtn
          className="ml-auto lg:flex flex-col justify-center items-center -mt-4 hidden w-24"
          data={{
            id: page.id,
            baslik: page.baslik,
            destination: page.destination,
            url: page.url,
            title: page.title,
            image: page.resim,
          }}
        />
        <div className="flex lg:gap-x-12 lg:mt-2 items-center order-last lg:order-none">
          <div className="flex flex-col">
            <h1 className="text-brand-black lg:text-xl hidden lg:block font-bold">
              {page.baslik}
            </h1>
            <Destination className="hidden lg:flex md:mt-2 lg:mt-0">
              {page.destination}
            </Destination>
          </div>
          <div className="gap-x-3 hidden lg:flex">
            {page.ribbon && (
              <span className="px-3 py-2 font-bold text-xxs border  rounded-sm">
                {page.ribbon}
              </span>
            )}
            {page.ribbon2 && (
              <span className="px-3 py-2 font-bold text-xxs border  rounded-sm">
                {page.ribbon2}
              </span>
            )}
          </div>
          {gavelBelgeNo || gavelBasvuruNo ? (
            <div className="text-xs border-2 border-[#DC0D15] rounded-md  py-2 text-center px-2 mx-auto lg:mr-0  lg:mt-5 mb-2 lg:mb-0 flex lg:flex-col">
              <div className="w-16 mx-auto">
                <Icon name={"ktb"} className={""} />
              </div>
              <div className="flex flex-col items-center justify-center mt-2">
                <span>T.C Kültür ve Turizm Bakanlığı</span>
                <span className="font-bold">
                  Belge
                  {gavelBelgeNo
                    ? " No : " + gavelBelgeNo
                    : gavelBasvuruNo
                    ? " Başvuru No: " + gavelBasvuruNo
                    : " Başvuru Sürecinde"}
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="h-0.5 bg-detail-border-color mt-9 hidden lg:block"></div>
        <div className="flex mt-5 lg:mt-7 lg:gap-x-14 justify-between mb-4 lg:mb-0">
          <div className="flex items-center justify-items-center">
            <div className="iconsImgFilter">
              <Icon name={"VillaItemProp1"}></Icon>
            </div>
            <div className="flex flex-col font-bold text-brand-gray-2 ml-3 leading-4 text-sm">
              <span>{page.kisi}</span>
              <span>{person}</span>
            </div>
          </div>
          <div className="flex items-center justify-items-center">
            <div className="iconsImgFilter">
              <Icon name={"VillaItemProp2"}></Icon>
            </div>
            <div className="flex flex-col font-bold text-brand-gray-2 ml-3 leading-4 text-sm">
              <span>{page.yatak_odasi}</span>
              <span>{bedRoom}</span>
            </div>
          </div>
          <div className="flex items-center justify-items-center">
            <div className="iconsImgFilter">
              <Icon name={"VillaItemProp3"}></Icon>
            </div>
            <div className="flex flex-col font-bold text-brand-gray-2 ml-3 leading-4 text-sm">
              <span>{page.banyo}</span>
              <span>{bathRoom}</span>
            </div>
          </div>

          <div className="font-bold text-13 text-brand-gray  items-center ml-auto lg:flex hidden gap-x-3">
            <span className="text-black">{shareUpper}</span>
            <ul className="flex gap-x-3 content-center items-center">
              <li className="relative inline-block cursor-pointer group">
                <Link
                  href={
                    "whatsapp://send/?text=" +
                    process.env.NEXT_PUBLIC_DOMAIN +
                    "/" +
                    page.url
                  }
                >
                  <a target={"_blank"}>
                    <FaWhatsapp size={22} />
                    <span className="group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ">
                      {shareViaWhatsapp}
                    </span>
                  </a>
                </Link>
              </li>
              <li className="relative inline-block cursor-pointer group">
                <Link
                  href={
                    "https://www.facebook.com/sharer/sharer.php?u=" +
                    process.env.NEXT_PUBLIC_DOMAIN +
                    "/" +
                    page.url
                  }
                >
                  <a target={"_blank"}>
                    <FaFacebookF size={20}></FaFacebookF>
                    <span className="group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ">
                      {shareViaFacebook}
                    </span>
                  </a>
                </Link>
              </li>

              <li className="relative inline-block cursor-pointer group">
                <Link
                  href={
                    "https://twitter.com/intent/tweet?text=" +
                    process.env.NEXT_PUBLIC_DOMAIN +
                    "/" +
                    page.url
                  }
                >
                  <a target={"_blank"}>
                    <FaTwitter size={22}></FaTwitter>
                    <span className="group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ">
                      {shareViaTwitter}
                    </span>{" "}
                  </a>
                </Link>
              </li>
              <li className="relative inline-block cursor-pointer group">
                <Link
                  href={
                    "mailto:?subject=" +
                    page.baslik +
                    "&body=" +
                    process.env.NEXT_PUBLIC_DOMAIN +
                    "/" +
                    page.url
                  }
                >
                  <a target={"_blank"}>
                    <FaRegEnvelope size={22}></FaRegEnvelope>
                    <span className="group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ">
                      {shareViaMail}
                    </span>{" "}
                  </a>
                </Link>
              </li>

              <li className="relative inline-block cursor-pointer group">
                <CopyToClipboard
                  text={process.env.NEXT_PUBLIC_DOMAIN + "/" + page.url}
                  onCopy={() => {}}
                >
                  <button>
                    <FaRegCopy size={22}></FaRegCopy>
                    <span className="group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ">
                      {copyLink}
                    </span>
                  </button>
                </CopyToClipboard>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderCard;
